import React from 'react';
import { Helmet } from 'react-helmet';
import { headerData } from '../../../data/headerData';
import { projectsData } from '../../../data/projectsData';
import { slugForId } from '../../../utils/projectSlug';
import SingleProject from '../../container/single-project';
import Navbar from '../../container/navbar';
import Reveal from '../../helper/reveal';
import './projectPage.css';

const ProjectPageUI = ({ search, setSearch, filteredArticles, tags = [], activeTag = '', setTag = () => {} }) => {
  return (
    <>
      <Helmet>
        <title>{`Projects | ${headerData.name}`}</title>
        <meta name='description' content={`Selected projects by ${headerData.name}, ${headerData.role}.`} />
        <link rel='canonical' href='https://miretu.vercel.app/projects' />
      </Helmet>
      <Navbar />
      <main id='main' className='projectPage'>
        <div className='container'>
          <Reveal className='section-head'>
            <span className='eyebrow'>Portfolio / Projects</span>
            <h1 className='section-title'>All projects.</h1>
          </Reveal>

          <div className='projectPage__search'>
            <label htmlFor='project-search'>Search projects</label>
            <input
              id='project-search'
              type='search'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder='Name, description or technology'
              autoComplete='off'
            />
            <p className='projectPage__count' role='status' aria-live='polite'>
              {filteredArticles.length} of {projectsData.length} projects
            </p>
          </div>

          {tags.length > 0 && (
            <div className='projectPage__tags' role='group' aria-label='Filter by technology'>
              <button
                type='button'
                className={`projectPage__tag${activeTag ? '' : ' is-active'}`}
                aria-pressed={!activeTag}
                onClick={() => setTag('')}
              >
                All
              </button>
              {tags.map(({ tag, count }) => (
                <button
                  key={tag}
                  type='button'
                  className={`projectPage__tag${activeTag === tag ? ' is-active' : ''}`}
                  aria-pressed={activeTag === tag}
                  onClick={() => setTag(activeTag === tag ? '' : tag)}
                >
                  {tag} <span>{count}</span>
                </button>
              ))}
            </div>
          )}

          {filteredArticles.length > 0 ? (
            <div className='projectPage__grid'>
              {filteredArticles.map((project, index) => (
                <SingleProject
                  key={project.id}
                  index={index}
                  id={project.id}
                  name={project.projectName}
                  desc={project.projectDesc}
                  tags={project.tags}
                  code={project.code}
                  slug={slugForId(project.id)}
                  headingLevel={2}
                />
              ))}
            </div>
          ) : (
            <p className='projectPage__empty'>No projects match{search ? <> “{search}”</> : ''}{activeTag ? <> with {activeTag}</> : ''}.</p>
          )}
        </div>
      </main>
    </>
  );
};

export default ProjectPageUI;
